import React from 'react';
import SuccessStep from './SuccessStep';

export default function ShippingStep({ t, kitReturn }) {
  return <SuccessStep data={kitReturn} t={t} />;
}
